import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEOSchema from "@/components/feature/SEOSchema";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import CategorySection from "./components/CategorySection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <SEOSchema type="home" />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}